/**
 * @file stickyCtaSignal.js
 * @description Tiny shared signal: is the sticky mobile CTA bar on screen right now?
 *   StickyMobileCta publishes it; TopNav reads it so the header CTA steps aside on phones
 *   while the bar is up (one ask per screen). Also mirrored to `document.body.dataset.stickyCta`
 *   ("on" | absent) for debugging and CSS-free inspection.
 * @module lib/stickyCtaSignal
 */
import { useEffect, useState } from "react";

let visible = false;
const listeners = new Set();

export function setStickyCtaVisible(next) {
  const v = !!next;
  if (v === visible) return;
  visible = v;
  if (typeof document !== "undefined" && document.body) {
    if (v) document.body.dataset.stickyCta = "on"; else delete document.body.dataset.stickyCta;
  }
  listeners.forEach((fn) => fn(v));
}

export const isStickyCtaVisible = () => visible;

export function useStickyCtaVisible() {
  const [v, setV] = useState(visible);
  useEffect(() => {
    listeners.add(setV);
    setV(visible);
    return () => { listeners.delete(setV); };
  }, []);
  return v;
}
